var _path, _path2, _circle, _g, _circle2, _g2, _circle3, _g3, _circle4, _g4, _circle5, _g5, _circle6, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGrowthGauge = function SvgGrowthGauge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 118,
    height: 91,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#growth-gauge_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E2D2C",
    d: "M33.158 72.929h6.552v6.876h-2.268l-.126-1.494c-.882 1.08-2.16 1.728-3.87 1.728-3.834 0-6.516-2.718-6.516-6.228 0-3.816 2.808-6.48 6.534-6.48 3.006 0 5.598 1.674 6.12 4.59H36.38c-.522-1.422-1.746-1.836-2.844-1.836-2.106 0-3.528 1.494-3.528 3.654 0 1.926 1.386 3.528 3.546 3.528 1.422 0 2.502-.72 3.114-1.908l-3.51-.036zm14.464-1.998v2.772c-1.422.054-2.322.432-3.006 1.098v5.004h-2.934v-8.73h2.934v.936c.774-.666 1.71-1.08 3.006-1.08m5.59-.09c2.807 0 4.787 1.926 4.787 4.608 0 2.7-1.98 4.59-4.788 4.59-2.807 0-4.805-1.89-4.805-4.59 0-2.682 1.998-4.608 4.806-4.608m0 6.768c1.205 0 2.051-.882 2.051-2.16 0-1.26-.846-2.16-2.051-2.16-1.225 0-2.07.9-2.07 2.16 0 1.278.845 2.16 2.07 2.16m16.044-6.534h3.06l-2.88 8.73h-2.592l-1.566-5.076-1.584 5.076h-2.592l-2.88-8.73h3.06l1.224 5.022 1.602-5.022h2.322l1.602 4.986zm10.903 5.922.324 2.61c-.9.378-1.836.432-2.34.432-2.376 0-3.816-1.548-3.816-3.906v-2.556h-1.71v-2.502h1.71v-2.97h2.916v2.97h2.97v2.502h-2.97v2.466c0 .9.522 1.314 1.368 1.314.558 0 1.026-.162 1.548-.36m7.105-6.156c2.196 0 3.708 1.494 3.708 3.978v4.986h-2.916v-4.518c0-1.242-.63-1.8-1.602-1.8-.522 0-1.08.27-1.584.828v5.49h-2.934v-12.78h2.934v4.626c.702-.522 1.458-.81 2.394-.81"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "growth-gauge_svg__b",
    width: 118,
    height: 58,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M.645.637h116.38v57.151H.645z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#growth-gauge_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "growth-gauge_svg__c",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 59.417,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#growth-gauge_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFA8B8",
    stroke: "#FFA8B8",
    d: "m53.76 53.606 3.41-1.2L40.244 2.848l-18.338 8.976-10.633 13.9z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "growth-gauge_svg__d",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 59.417,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#growth-gauge_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FD8FA4",
    stroke: "#FD8FA4",
    d: "M57.12 50.497 40.226.52l18.402-4.252L77.71.08 61.28 50.75z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "growth-gauge_svg__e",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 59.417,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#growth-gauge_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D93657",
    stroke: "#D93657",
    d: "M106.952 23.452 68.34 49.827l3.868 7.525h46.347l-3.586-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "growth-gauge_svg__f",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 59.417,
    r: 57.69,
    fill: "#D9D9D9",
    stroke: "#FDEFE0"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#growth-gauge_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE1E7",
    stroke: "#FFE1E7",
    d: "m10.716 23.452 38.612 26.375-3.868 7.525H-.887l3.586-20.677z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "growth-gauge_svg__g",
    width: 118,
    height: 117,
    x: 0,
    y: 1,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.834,
    cy: 59.417,
    r: 58.19,
    fill: "#D9D9D9"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#growth-gauge_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FC6481",
    stroke: "#FC6481",
    d: "m65.199 52.202-3.43-1.143L77.872 1.228l18.484 8.67 10.862 13.722z"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.833,
    cy: 59.424,
    r: 26.263,
    fill: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "m65.162 42.862 5.355-.67.686 5.48M59.653 56.537l9.964-13.151"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "growth-gauge_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .637h118v90H0z"
  })))));
};
export { SvgGrowthGauge as ReactComponent };
export default __webpack_public_path__ + "images/growth-gauge.svg";